export const PWA_VERSION = '3.0.1';
export const REGISTER_CRYODEX = 'REGISTER_CRYODEX';
export const LOGIN_CRYODEX = 'LOGIN_CRYODEX';
export const RESET_PASSWORD_CRYODEX = 'RESET_PASSWORD_CRYODEX';

export const CRYODEX_GET_COUNTRIES = 'CRYODEX_GET_COUNTRIES';


export const CRYODEX_UPDATE_COUNTRIES = 'CRYODEX_UPDATE_COUNTRIES';
export const CRYODEX_UPDATE_CITIES = 'CRYODEX_UPDATE_CITIES';

export const CRYODEX_PROGRESS_START = 'CRYODEX_PROGRESS_START';
export const CRYODEX_PROGRESS_STOP = 'CRYODEX_PROGRESS_STOP';

export const CRYODEX_NOTIFICATION_START = 'CRYODEX_NOTIFICATION_START';
export const CRYODEX_NOTIFICATION_STOP = 'CRYODEX_NOTIFICATION_STOP';


//feed actions
export const CRYODEX_GET_USER = 'CRYODEX_GET_USER';
export const CRYODEX_USER_CURRENT_GET = 'CRYODEX_GET_USER';
export const CRYODEX_UPDATE_USER = 'CRYODEX_UPDATE_USER';
export const CRYODEX_CRYODEX_LINKS_GET = 'CRYODEX_CRYODEX_LINKS_GET';
export const CRYODEX_CRYODEX_LINKS_UPDATE = 'CRYODEX_CRYODEX_LINKS_UPDATE';
export const CRYODEX_CRYODEX_INFODEX_UNLINK = 'CRYODEX_CRYODEX_INFODEX_UNLINK';

export const CRYODEC_GET_ISOLATED_CRYODEX = 'CRYODEC_GET_ISOLATED_CRYODEX';
export const CRYODEX_UPDATE_ISOLATED_CRYODEX = 'CRYODEX_UPDATE_ISOLATED_CRYODEX';

//check friendship
export const CRYODEX_CHECK_FRIENDSHIP = 'CRYODEX_CHECK_FRIENDSHIP';

export const CRYODEX_CRYODEX_ALL_GET = 'CRYODEX_CRYODEX_ALL_GET';
export const CRYODEX_CRYODEX_UPDATE = 'CRYODEX_CRYODEX_UPDATE';
export const CRYODEX_CRYODEX_CURRENT_GET = 'CRYODEX_CRYODEX_CURRENT_GET';
export const CRYODEX_CRYODEX_CURRENT_UPDATE = 'CRYODEX_CRYODEX_CURRENT_UPDATE';
export const CRYODEX_CRYODEX_LINKED_GET = 'CRYODEX_CRYODEX_LINKED_GET';
export const CRYODEX_CRYODEX_LINKED_UPDATE = 'CRYODEX_CRYODEX_LINKED_UPDATE';
export const CRYODEX_CRYODEX_GROUPS_MAP_RELATIONSHIP = 'CRYODEX_CRYODEX_GROUPS_MAP_RELATIONSHIP';
export const CRYODEX_CRYODEX_GROUPS_MEMBER_DELETE = 'CRYODEX_CRYODEX_GROUPS_MEMBER_DELETE';

// CryodexInfodexLink
export const CRYODEX_CRYODEX_INFODEX_LINK_UPDATE = 'CRYODEX_CRYODEX_INFODEX_LINK_UPDATE';
    
// Isolated Cryodex
export const CRYODEX_GET_SELECTED_CRYODEX = 'GET_SELECTED_CRYODEX';
export const CRYODEX_GET_INVITE = 'CRYODEX_SEND_INVITE';
export const CRYODEX_INVITE_UPDATE = 'CRYODEX_INVITE_UPDATE';

export const CRYODEX_GET_LOCATION = 'CRYODEX_GET_LOCATION';
export const CRYODEX_UPDATE_LOCATION = 'CRYODEX_UPDATE_LOCATION';   

export const CRYODEX_FIREBASE_TOKEN_UPDATE = 'CRYODEX_FIREBASE_TOKEN_UPDATE';

export const CRYODEX_INFODEX_LINKED_GET = 'CRYODEX_INFODEX_LINKED_GET';
export const CRYODEX_INFODEX_LINKED_UPDATE = 'CRYODEX_INFODEX_LINKED_UPDATE';
export const CRYODEX_INFODEX_LINKED_STATUS_UPDATE = 'CRYODEX_INFODEX_LINKED_STATUS_UPDATE';


export const CRYODEX_INFODEX_FAVOURED_GET = 'CRYODEX_INFODEX_FAVOURED_GET';
export const CRYODEX_INFODEX_FAVOURED_UPDATE = 'CRYODEX_INFODEX_FAVOURED_UPDATE';

export const CRYODEX_INFODEX_GET = 'CRYODEX_INFODEX_GET';
export const INFODEX_ALL_GET = 'INFODEX_ALL_GET';
export const CRYODEX_INFODEX_UPDATE = 'CRYODEX_INFODEXES_UPDATE';
export const CRYODEX_INFODEX_CURRENT_GET = 'CRYODEX_INFODEX_CURRENT_GET';
export const CRYODEX_INFODEX_CURRENT_UPDATE = 'CRYODEX_INFODEX_CURRENT_UPDATE';

export const CRYODEX_INFODEX_GROUPS_CREATE = 'CRYODEX_INFODEX_GROUPS_CREATE';
export const CRYODEX_INFODEX_GROUPS_DELETE = 'CRYODEX_INFODEX_GROUPS_DELETE';
export const CRYODEX_INFODEX_GROUPS_RENAME = 'CRYODEX_INFODEX_GROUPS_RENAME';
export const CRYODEX_INFODEX_GROUPS_GET = 'CRYODEX_INFODEX_GROUPS_GET';
export const CRYODEX_INFODEX_GROUPS_UPDATE = 'CRYODEX_INFODEX_GROUPS_UPDATE';
export const CRYODEX_INFODEX_GROUPS_MEMBER_DELETE = 'CRYODEX_INFODEX_GROUPS_MEMBER_DELETE';


export const CRYODEX_INFODEX_LINK_GET = 'CRYODEX_INFODEX_LINK_GET';
export const CRYODEX_INFODEX_LINK_UPDATE = 'CRYODEX_INFODEX_LINK_UPDATE';

export const CRYODEX_USER_GROUPS_CREATE = 'CRYODEX_USER_GROUPS_CREATE';
export const CRYODEX_USER_GROUPS_DELETE = 'CRYODEX_USER_GROUPS_DELETE';
export const CRYODEX_USER_GROUPS_RENAME = 'CRYODEX_USER_GROUPS_RENAME';
export const CRYODEX_USER_GROUPS_GET = 'CRYODEX_USER__GROUPS_GET';
export const CRYODEX_USER_GROUPS_UPDATE = 'CRYODEX_USER__GROUPS_UPDATE';
export const CRYODEX_USER_GROUPS_MAP_RELATIONSHIP = 'CRYODEX_USER_GROUPS_MAP_RELATIONSHIP';

// Edit Cryodex
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const CRYODEX_EDIT_UPDATE = 'CRYODEX_EDIT_UPDATE';

// Mailbox Actions
export const MAILBOX_GET = 'app/MAILBOX_GET';
export const MAILBOX_GET_UPDATE = 'app/MAILBOX_GET_UPDATE';
export const MAILBOX_UPDATE_INVITE = 'app/MAILBOX_UPDATE_INVITE';

export const SUCCESS = 'ALERT_SUCCESS';
export const ERROR = 'ALERT_ERROR';
export const CLEAR = 'ALERT_CLEAR';

export const SAVING_COMPLETE = "SAVING_COMPLETE";
export const SAVING_CLOSED = "SAVING_CLOSED";

//gps
export const START_LOCATION_TRACKING = 'START_LOCATION_TRACKING';
export const STOP_LOCATION_TRACKING = 'STOP_LOCATION_TRACKING';
export const LOCATION_TRACKING_FAILED = 'LOCATION_TRACKING_FAILED';

export const UN_ASSIGNED_LINKED_INFODEX_IMAGE_SOURCE = 'https://127.0.0.1:8000/infodex_unknown.png';
export const UN_ASSIGNED_LINKED_INFODEX_NAME = 'YOU HAVE NOT JOINED ANY FAVOURITE PLACE';
export const DEFAULT_GROUP = 'DEFAULT';
export const SPECIFIED_GROUP = 'SPECIFIED';


export const SETTINGS_GET = "app/SETTINGS_GET";
export const SETTINGS_UPDATE = "app/SETTINGS_UPDATE";
export const SETTINGS_SAVE = "app/SETTINGS_SAVE";
export const SETTINGS_SAVE_COMPLETE = "app/SETTINGS_SAVE_COMPLETE";
export const SETTINGS_TERMS = 'https://127.0.0.1:8000/terms';

//---
export const GET_FRIENDS = "GET_FRIENDS";
export const UPDATE_FRIENDS = 'UPDATE_FRIENDS';
export const GET_ALL_FRIENDS = "GET_ALL_FRIENDS";
export const GET_GFS = "GET_GFS";
export const GET_GF = "GET_GF";
export const GET_GPLACES = "GET_GPLACES";
export const GET_ALL_FRIENDS_GOING_TO_MY_LOCATION = 'GET_ALL_FRIENDS_GOING_TO_MY_LOCATION';
export const UPDATE_ALL_FRIENDS_GOING_TO_MY_LOCATION = 'UPDATE_ALL_FRIENDS_GOING_TO_MY_LOCATION';


